import React from 'react';
import { Title, StyledText, ButtonContainer } from './HowToSpell.styles';
import Button from '../../utils/Button/Button';
import { useNavigate } from 'react-router-dom';
import FormContainer from '../../utils/FormContainer/FormContainer';
import { useSelector } from 'react-redux';
import { selectInvitationGuestMembers } from '../../../store/slice/rsvp/slice';

const EnterFullName = () => {
  const navigate = useNavigate();
  const { data } = useSelector(selectInvitationGuestMembers);

  const onEdit = () => {
    const query = { step: 'EDIT' };
    const queryString = new URLSearchParams(query).toString();
    const url = `/wedding-guest?${queryString}`;

    navigate(url);
  };

  const onContinue = () => {
    const query = { step: 'ATTENDING' };
    const queryString = new URLSearchParams(query).toString();
    const url = `/wedding-guest?${queryString}`;

    navigate(url);
  };

  return (
    <FormContainer message={'Tell us how to spell the name correctly'} gap>
      <Title>{data[0]?.firstName + ' ' + data[0]?.lastName}</Title>
      <ButtonContainer>
        <Button title={'Continue'} onClick={onContinue} width />
        <StyledText onClick={onEdit}>Edit</StyledText>
      </ButtonContainer>
    </FormContainer>
  );
};

export default EnterFullName;
